import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import MailBodyEditorContent from "@pages/email/common/view/MailBodyEditorContent";

const FullMailSubjectTemp = (props) => {
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [subject, setSubject] = useState("");

    const {content, onChange} = props

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        setSubject(content)
    }, [content])

    const onChangeContent = (changeContent) => {
        setSubject(changeContent)
        onChange(changeContent)
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title'><b>Email Subject</b></h3>
                </div>
                <div className='card-body p-0'>
                    <MailBodyEditorContent
                        onlyAddFieldTool
                        name={"full-mail-subject-temp"}
                        onChange={(values) => onChangeContent(values)}
                        content={subject}/>
                </div>
            </div>
        </>
    )
}

export default FullMailSubjectTemp;
